import { en } from './en.js'

export const id = structuredClone(en)
